// Company status helper functions

// Helper function to get company status badge color
export const getCompanyStatusColor = (status) => {
    const colors = {
        'active': 'bg-green-100 text-green-700',
        'expired': 'bg-red-100 text-red-700',
        'expiring_soon': 'bg-orange-100 text-orange-700',
        'suspended': 'bg-gray-100 text-gray-700'
    };
    return colors[status] || 'bg-gray-100 text-gray-700';
};

// Helper function to get company status label
export const getCompanyStatusLabel = (status) => {
    const labels = {
        'active': 'Active',
        'expired': 'Expired',
        'expiring_soon': 'Expiring Soon',
        'suspended': 'Suspended'
    };
    return labels[status] || status;
};

// Helper function to check if subscription is expiring soon (within 30 days)
export const isExpiringSoon = (expiryDate) => {
    const expiry = new Date(expiryDate);
    const today = new Date();
    const daysUntilExpiry = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
    return daysUntilExpiry > 0 && daysUntilExpiry <= 30;
};

// Helper function to check if subscription is expired
export const isExpired = (expiryDate) => {
    const expiry = new Date(expiryDate);
    const today = new Date();
    return expiry < today;
};
